module.exports = __webpack_public_path__ + "static/media/prototype-preset-card.9c46e1f6.gif";